import axios from "axios";

// Renew Token
export const RENEW_ACCESS_TOKEN =
  process.env.REACT_APP_BACKEND_PUBLIC_API + "v1/auth/renewAccessToken";
export const SEND_LOGIN_OTP =
  process.env.REACT_APP_BACKEND_PUBLIC_API + "v1/user/auth/sendOtp";
export const VERIFY_LOGIN_OTP =
  process.env.REACT_APP_BACKEND_PUBLIC_API + "v1/user/auth/verifyOtp";

// GET =>  renew AccessToken
export function renewAccessToken(refreshToken) {
  return axios.post(RENEW_ACCESS_TOKEN, refreshToken);
}

//  get Otp
export function sendLoginOtp(email) {
  return axios.post(SEND_LOGIN_OTP, {
    email,
    role: "consumer",
    trackingPriority: 0,
    frontendAction: "User.login",
  });
}

//verify login otp
export function verifyLoginOtp(otp, email) {
  return axios.post(VERIFY_LOGIN_OTP, {
    otp,
    email,
    trackingPriority: 0,
    frontendAction: "User.login",
  });
}
